import React from 'react';
import { Button } from '@/components/ui/button';
import type { PaymentFilterValues } from '../../types/paymentFilter.types';

export interface AppliedFiltersBannerProps {
  appliedFilters: PaymentFilterValues | null;
  onClearFilters: () => void;
}

export const AppliedFiltersBanner: React.FC<AppliedFiltersBannerProps> = ({
  appliedFilters,
  onClearFilters,
}) => {
  if (!appliedFilters) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <span className="text-sm text-blue-800">Advanced filters applied</span>
        <Button variant="outline" size="sm" onClick={onClearFilters}>
          Clear Filters
        </Button>
      </div>
    </div>
  );
};

export default AppliedFiltersBanner;
